import { render } from "./orderdetail.vue?vue&type=template&id=f4fca09e&scoped=true"
import script from "./orderdetail.vue?vue&type=script&lang=js"
export * from "./orderdetail.vue?vue&type=script&lang=js"

import "./orderdetail.vue?vue&type=style&index=0&id=f4fca09e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4fca09e"]])

export default __exports__